import { useEffect, useRef } from 'react';

export const PointsList = ({ 
  points = [], 
  activeService,
  serviceConfig,
  onPointClick 
}) => {
  const listRef = useRef(null);

  useEffect(() => {
    console.error('[DEBUG] PointsList: Received points:', points?.length || 0);
    if (points && points.length > 0) {
      console.error('[DEBUG] PointsList: First point:', points[0]);
    }
    if (serviceConfig) {
      console.error('[DEBUG] PointsList: serviceConfig color:', serviceConfig.color || serviceConfig.clusterColor);
    }
  }, [points, serviceConfig]);

  const handlePointClick = (point) => {
    if (onPointClick) {
      onPointClick(point);
    }
  };

  if (!points || points.length === 0) {
    return (
      <div className="points-list-container">
        <div className="points-list-title">Encuentra dónde usar Flypass</div>
        <div className="points-list-empty">
          No hay puntos disponibles para este servicio
        </div>
      </div>
    );
  }

  return (
    <div className="points-list-container">
      <div className="points-list-title">Encuentra dónde usar Flypass</div>
      <div className="points-list" ref={listRef}>
        {points.map((point) => (
          <div
            key={point.id}
            className="points-list-item"
            onClick={() => handlePointClick(point)}
          >
            <div className="points-list-item-content">
              <div className="points-list-item-name">{point.title || 'Sin nombre'}</div>
              <div className="points-list-item-location">{point.city || 'Sin ciudad'}</div>
            </div>
            {serviceConfig && (
              <div 
                className="points-list-item-badge" 
                style={{ 
                  backgroundColor: serviceConfig.color || serviceConfig.clusterColor || '#4ECDC4' 
                }}
              >
                {serviceConfig.label || activeService}
              </div>
            )}
            <div className="points-list-item-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
};

